// extracted by mini-css-extract-plugin
export default {"root":"GuidePage_root__UR1B2"};